import { ReactComponent as AttentionIconSVG } from '../assets/images/circle-exclaimation-icon.svg';

const StatusAttention = () => {
  return <AttentionIconSVG className="text-alert-yellow" width="15px" />;
}

export default StatusAttention;
